import {
    Box,
    Button,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    useColorModeValue,
    useRadio,
    Text,
    HStack,
    useRadioGroup,
    Textarea
} from '@chakra-ui/react';
import layoutStore from '../stores/layoutStore';
import { useState } from 'react';
import useStore from '../stores/store';
import { postFeedbackFront } from '../../platformFiles/platformMessages';
import { showToast } from '../Utils/showToastWrapper';

const FeedbackModal = () => {
    const showFeedbackModal = layoutStore((state) => state.showFeedbackModal);
    const setShowFeedbackModal = layoutStore(
        (state) => state.setShowFeedbackModal
    );
    const onClose = () => {
        setShowFeedbackModal(false);
    };

    const [loading, setIsLoading] = useState(false);

    const submitFeedback = async () => {
        let userData = useStore.getState().userData;
        let feedbackObj = {
            userId: userData ? userData.userId : 'anonymous',
            userEmail: userData.email ? userData.email : 'anonymous',
            type: currentOption,
            description: textValue
        };
        setIsLoading(true);
        let post = await postFeedbackFront(feedbackObj);
        if (post.data.success) {
            showToast(
                'Feedback submitted 👍️',
                'We really appreciate your valuable input 🙏!',
                'success'
            );
        } else {
            showToast(
                'Faild to submit feedback',
                'Something went wrong. Please try again or send via support@tabos.cloud',
                'error'
            );
        }

        onClose();
    };
    const modalBg = useColorModeValue('#FFF', '#262A2D');
    const icon = useColorModeValue('gray.500', '#A1A2A4');

    const [currentOption, setCurrentOption] = useState('💡 Idea');
    const options = ['💡 Idea', '🚧 Issue/Bug', '🧩 Other'];

    const { getRootProps, getRadioProps } = useRadioGroup({
        name: 'framework',
        defaultValue: '💡 Idea',
        onChange: (val) => setCurrentOption(val)
    });

    const group = getRootProps();

    let textAreaLabel = {
        '💡 Idea': 'Describe your idea and usecase',
        '🚧 Issue/Bug': 'Describe the issue/bug in detail',
        '🧩 Other': 'Other thoughts here'
    };

    let [textValue, setText] = useState('');

    let handleInputChange = (e) => {
        let inputValue = e.target.value;
        setText(inputValue);
    };

    return (
        <>
            <Modal isOpen={showFeedbackModal} onClose={onClose} size="544px">
                <ModalOverlay style={{ backdropFilter: 'blur(1px)' }} />
                <ModalContent rounded="14px" bg={modalBg} w="432px">
                    <ModalHeader
                        fontSize="20px"
                        fontWeight="700"
                        pt="2rem"
                        pb="4px"
                        px="20px"
                    >
                        Send feedback
                    </ModalHeader>
                    <ModalCloseButton
                        size="sm"
                        mt="4px"
                        transition="0s"
                        rounded="6px"
                        color={icon}
                    />
                    <ModalBody px="20px">
                        <Text fontSize="14px" color="secondaryText">
                            Please share your feedback with us. We appreciated
                            and value your input.
                        </Text>
                        <HStack {...group} mt="16px" gap="12px">
                            {options.map((value) => {
                                const radio = getRadioProps({ value });
                                return (
                                    <RadioCard key={value} {...radio}>
                                        {value}
                                    </RadioCard>
                                );
                            })}
                        </HStack>
                        <Textarea
                            value={textValue}
                            onChange={handleInputChange}
                            placeholder={textAreaLabel[currentOption]}
                            size="sm"
                            rounded="8px"
                            resize={'none'}
                            mt="8px"
                        />
                    </ModalBody>
                    <ModalFooter p="4px 20px 16px">
                        <Button
                            onClick={onClose}
                            transition="0s"
                            rounded="8px"
                            mr="8px"
                        >
                            Cancel
                        </Button>
                        <Button
                            onClick={() => submitFeedback()}
                            isLoading={loading}
                            rounded="8px"
                            bg="linear-gradient(145deg, #5DABFE 0%, #3391FF 100%)"
                            boxShadow={
                                '0 2px 3px -3px #287AD5, rgba(70, 94, 193, 0.25) -1px -1px 1px 0px inset'
                            }
                            _hover={{ bg: '', filter: 'brightness(1.05)' }}
                            _active={{ bg: '', filter: 'brightness(0.98)' }}
                            transition={'0.1s'}
                            color="#FFF"
                        >
                            <SendIcon />
                            Send
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </>
    );
};

export default FeedbackModal;

const SendIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="#FFF"
            style={{ width: '16px', height: '16px', marginRight: '8px' }}
        >
            <path
                d="M22.126 12.6649C22.3332 12.2459 22.3332 11.7543 22.126 11.3353C21.9436 10.9663 21.6235 10.7729 21.4576 10.6795C21.2791 10.5791 21.0503 10.4761 20.8221 10.3735L4.03833 2.82085C3.8049 2.71576 3.57218 2.61099 3.37587 2.54299C3.19564 2.48056 2.83277 2.36649 2.431 2.47828C1.97699 2.60461 1.60873 2.93697 1.43666 3.3757C1.2844 3.76393 1.36078 4.13656 1.40447 4.32223C1.45205 4.52448 1.5325 4.76673 1.61319 5.0097L3.23767 9.90402C3.36847 10.2981 3.43387 10.4951 3.55548 10.6408C3.66287 10.7695 3.80088 10.8691 3.95681 10.9305C4.13339 11 4.341 11 4.75621 11H11.9999C12.5522 11 12.9999 11.4477 12.9999 12C12.9999 12.5523 12.5522 13 11.9999 13H4.77512C4.36096 13 4.15387 13 3.97761 13.0692C3.82195 13.1304 3.68412 13.2296 3.57672 13.3578C3.4551 13.503 3.38936 13.6993 3.25788 14.0921L1.62033 18.9836C1.53876 19.2272 1.45752 19.4697 1.40932 19.6722C1.36513 19.8578 1.28747 20.2311 1.43932 20.6203C1.6108 21.0599 1.97909 21.3931 2.43353 21.52C2.83596 21.6323 3.19965 21.5178 3.37994 21.4553C3.57664 21.3872 3.80993 21.2822 4.04413 21.1767L20.8221 13.6267C21.0502 13.524 21.2791 13.4211 21.4577 13.3206C21.6235 13.2273 21.9436 13.0338 22.126 12.6649Z"
                fill="currentColor"
            ></path>
        </svg>
    );
};

function RadioCard(props) {
    const { getInputProps, getRadioProps } = useRadio(props);

    const input = getInputProps();
    const checkbox = getRadioProps();
    return (
        <Box as="label">
            <input {...input} />
            <Box
                {...checkbox}
                cursor="pointer"
                borderWidth="1px"
                borderRadius="8px"
                _checked={{
                    bg: 'linear-gradient(145deg, #5DABFE 0%, #3391FF 100%)',
                    color: 'white',
                    borderColor: 'blue.400'
                }}
                _focus={{
                    boxShadow: 'outline'
                }}
                p={'6px 16px'}
                fontWeight={600}
                fontSize={'14px'}
            >
                {props.children}
            </Box>
        </Box>
    );
}
